export function splitClassList(classLists) {
    const normalizedClassList = {};
    for (const classes in classLists) {
        const classesCondition = classLists[classes];
        classes.split(' ').forEach((classname) => {
            if (classname)
                normalizedClassList[classname] = classesCondition;
        });
    }
    return normalizedClassList;
}
//# sourceMappingURL=classMap.js.map